import useStripePayment, { StripePaymentResult } from "./useStripePayment";
import useHyperPayment, { HyperPaymentResult } from "./useHyperPayment";
import useRefundPayment from "./useRefundPayment";

export enum PaymentProvider {
  STRIPE = "stripe",
  NARVAR = "narvar",
}
interface PaymentProps {
  secret: string;
  paymentProvider: string;
  paymentNarvarRefId: string;
  paymentRequired: boolean;
}

export type SubmitPaymentCheckoutFn = () => Promise<
  StripePaymentResult | HyperPaymentResult
>;

export interface BasePaymentProviderReturn {
  capturingPayment: boolean;
  succeededPaymentIntentId: string;
  makePayment: SubmitPaymentCheckoutFn;
  paymentError?: string;
  isPaymentConfigurationError: boolean;
  eligiblePaymentProvider: string;
}

const usePayment = ({
  secret,
  paymentProvider,
  paymentNarvarRefId,
  paymentRequired,
}: PaymentProps): BasePaymentProviderReturn => {
  const refundPayment = useRefundPayment();
  const stripePayment = useStripePayment({ secret });
  const hyperPayment = useHyperPayment({
    paymentNarvarRefId,
  });

  if (!paymentRequired) {
    return refundPayment;
  }
  if (
    paymentProvider === PaymentProvider.NARVAR &&
    !hyperPayment.isPaymentConfigurationError
  ) {
    return hyperPayment;
  }
  return { ...stripePayment };
};

export default usePayment;
